import {useHistory} from 'react-router-dom';
import {Translate} from 'react-redux-i18n';
import {DOCUMENT_STATE} from 'front-onceforall-core/dist/utils/documents';
import {Icon} from 'front-onceforall-core';
import {EqualHeightElement} from 'react-equal-height';
import {captureError} from '../../../../../utils/log';
import {useCustomStore} from '../DepositorSectionStore';
import constructDataElement from '../../../../documentsStats/utils/constructDataElement';
import DocumentsStats from '../../../../documentsStats';
import {useDossierCountry} from '../../../OrganisationDashboardContainer';
import {getDocumentsByCountry} from '../../../../../utils/document';

function StatsView() {
  const history = useHistory();
  const {state: {documents, loading, error}} = useCustomStore();
  const dossierCountry = useDossierCountry();

  const states = getDocumentsByCountry(documents, dossierCountry)
    .filter(document => document.overallStatusDocument)
    .map(document => document.state);
  let todo = 0;
  let awaiting = 0;
  let almostExpired = 0;
  let valid = 0;

  states.forEach(state => {
    switch (state) {
      case DOCUMENT_STATE.AWAITING_SIGNATURE:
      case DOCUMENT_STATE.EXPIRED:
      case DOCUMENT_STATE.MISSING:
      case DOCUMENT_STATE.REJECTED:
        todo += 1;
        break;
      case DOCUMENT_STATE.AWAITING_VALIDATION:
      case DOCUMENT_STATE.AWAITING_GATHERING:
        awaiting += 1;
        break;
      case DOCUMENT_STATE.ALMOST_EXPIRED:
        almostExpired += 1;
        break;
      case DOCUMENT_STATE.VALID:
      case DOCUMENT_STATE.NOT_APPLICABLE:
      case DOCUMENT_STATE.SIGNED:
        valid += 1;
        break;
      default:
        captureError(`There is an unrecognized state : ${state}`);
    }
  });

  function getRatio(category) {
    if (states.length === 0) {
      return 0;
    }

    return Number(((category / states.length) * 100).toFixed(0));
  }

  const data = [
    constructDataElement(getRatio(todo), '#fb3958', 'document.chart.todo', false),
    constructDataElement(getRatio(almostExpired), '#ffa21a', 'document.chart.almostExpired', true),
    constructDataElement(getRatio(awaiting), '#518bd1', 'document.chart.awaiting', false),
    constructDataElement(getRatio(valid), '#3fd2b0', 'document.chart.valid', true)
  ];

  const actions = (
    <button
      type="button"
      className="small secondary flex-container"
      onClick={() => history.push('/documents')}
    >
      <Icon icon="document-page"/>
      <Translate value="document.chart.seeMyDocuments"/>
    </button>
  );

  return (
    <EqualHeightElement name="DashboardStats">
      <DocumentsStats
        data={data}
        loading={loading}
        error={error}
        actions={actions}
        title="dashboard.documents"
      />
    </EqualHeightElement>
  );
}

export default StatsView;
